import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';
import BetslipNotifications from 'modules/betslip-notifications/index.js';
import { isEmpty } from 'mojito/utils';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';

const { actions: betslipActions } = MojitoServices.Betslip;
const { AbsolutePane } = MojitoPresentation.Components;
const { usePreviousValue } = MojitoPresentation.Hooks;
const SECOND = 1000;

const PlacementMessages = ({ placementErrors, mojitoTools: { config } }) => {
    const errorTimeoutRef = useRef();
    const prevPlacementErrors = usePreviousValue(placementErrors);
    const dispatch = useDispatch();

    if (isEmpty(placementErrors)) {
        return null;
    }

    const { errorsTimeout } = config;

    if (!isEmpty(placementErrors) && placementErrors !== prevPlacementErrors) {
        errorTimeoutRef && clearTimeout(errorTimeoutRef.current);
        errorTimeoutRef.current = setTimeout(() => {
            dispatch(betslipActions.processErrors(placementErrors));
        }, errorsTimeout * SECOND);
    }

    return (
        <AbsolutePane config={config.container} class="ta-PlacementMessages">
            <BetslipNotifications config={config.errors} errors={placementErrors} />
        </AbsolutePane>
    );
};

export default PlacementMessages;
